import { useEffect, useState } from 'react';
let increment = 0;
export const useGalleryId = () => {
    const [id, setId] = useState();
    useEffect(() => {
        setId(`:media-gallery-id-${increment++}`);
    }, []);
    return id;
};
